import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit {
  @Input() public parentForm:FormGroup;
  @Input() public parentFormControlName: string = "";
  @Input() selectOptions:string[];
  @Input() placeholder:string;
  @Input() optionHoverColor:string;
  /**
   * Bloquea el despliegue de la lista: el valor se sigue viendo pero no se puede
   * cambiar. Lo usa quien monta el select sobre un formulario en solo lectura.
   */
  @Input() disabled: boolean = false;
  @Output() selectChange = new EventEmitter<string>();

  openSelect: boolean = false;
  selectedValue:string;

  constructor() { }

  ngOnInit() { }

  /** Abre/cierra la lista de opciones; no hace nada si el select está bloqueado. */
  toggleOpen(){
    if (this.disabled) return;
    this.openSelect = !this.openSelect;
  }

  onSelectedOption(selectedItem){
    this.openSelect = false;
    this.selectedValue = selectedItem;      
    this.selectChange.emit(this.selectedValue);  
  }

  handleClickedOutside(){
    this.openSelect = false;
  }

  // onSelectChange(selectedValue: any) {
  //   selectedValue.stopPropagation();
  //   this.SelectedValue = selectedValue.detail.value;  
  //   this.selectChange.emit(this.SelectedValue);  
  // }

}
